import * as React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

export default function ArrowDownIcon({ fill }) {
    return (
        <SvgIcon style={{ cursor: 'pointer' }}>
            <svg width="24" height="8" viewBox="0 0 24 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.99847 7.17014C5.88697 7.17014 5.78268 7.1504 5.6856 7.11091C5.58851 7.07141 5.49411 7.00619 5.40239 6.91524L0.452395 1.96524C0.299145 1.81099 0.226686 1.60867 0.23502 1.35827C0.243353 1.10785 0.324145 0.905014 0.477395 0.749764C0.663995 0.561181 0.867078 0.479389 1.08664 0.504389C1.30621 0.529389 1.50096 0.618515 1.67089 0.771765L5.99915 5.10004L10.3274 0.771765C10.4827 0.618515 10.6862 0.533556 10.9381 0.516889C11.19 0.500223 11.3926 0.58604 11.5459 0.77434C11.7325 0.929307 11.8133 1.12821 11.7883 1.37106C11.7633 1.61393 11.6741 1.82032 11.5209 1.99024L6.59589 6.91524C6.50393 7.00619 6.40924 7.07141 6.31184 7.11091C6.21444 7.1504 6.10999 7.17014 5.99847 7.17014Z"
                    fill={fill}
                />
            </svg>
        </SvgIcon>
    );
}
